module.exports = __webpack_public_path__ + "images/coupon_299-2dc886713b7ceccb596ed2db178dc1d1.png";